import { useEffect, useRef, useState } from "react";
import Button from "../../../components/reusable/Button/Button";
import TableList from "../../../components/TableList/TableList";
import PageLoader from "../../../components/reusable/PageLoader/PageLoader";
import Input from "../../../components/reusable/Input/Input";
import { useAppDispatch } from "../../../app/store";
import { useSelector } from "react-redux";
import { inicializarAlumno } from "../../../features/Dashboard/AsyncThunks/alumnos/inicializarAlumno";
import {
  getAlumnosInicializados,
  postBorrarIPO,
  postBorrarTodosLosAlumnos,
  postInvalidarOfertas,
  postResetearIPO,
  postSincronizarAlumnos,
  postSincronizarAlumnosPorPromocion,
  postVencerOfertas,
} from "../../../features/Dashboard/AsyncThunks/alumnos/getAlumnosInicializados";
import {
  selectAlumnosCarreras,
  selectAlumnosInicializados,
  setCarreraSearch,
  setEstadoAlumnoSearch,
  setRegistradosCurrentPage,
} from "../../../features/Dashboard/Slices/alumnosSlice";
import { setLoadingPageScreen } from "../../../features/Dashboard/Slices/dashboardSlice";
import ModalConfirmation from "../../../components/reusable/ModalConfirmation/ModalConfirmation";
import SlButton from "@shoelace-style/shoelace/dist/react/button";
import SlDrawer from "@shoelace-style/shoelace/dist/react/drawer";
import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import {
  selectGlobalFlags,
  setDrawerInicializar,
} from "../../../features/Dashboard/Slices/globalFlagsSlice";
import { getAlumnosRegistrados } from "../../../features/Dashboard/AsyncThunks/alumnos/getAlumnosRegistrados";
import moment from "moment";
import Divider from "../../../components/reusable/Divider/Divider";
import { toastError, toastSuccess } from "../../../utils/toast";
import useAuth from "../../../hooks/useAuth";
import { inicializarAlumnosByIdPersonaList } from "../../../features/Dashboard/AsyncThunks/alumnos/inicializarAlumnosPorIdPersona";
import { isFulfilled } from "@reduxjs/toolkit";
import { EstadoAlumnoCarrera, normalizeEstado } from "../../../enums/alumnos.enum";

function AlumnosInicializados() {
  const alumnosInicializados = useSelector(selectAlumnosInicializados);
  const { drawerInicializar } = useSelector(selectGlobalFlags);
  const [email, setEmail] = useState("");
  const [identificacion, setIdentificacion] = useState("");
  const [programa, setPrograma] = useState("");
  const [orientacion, setOrientacion] = useState("");
  const [promocion, setPromocion] = useState(moment().year().toString());
  const [mes, setMes] = useState("1");
  const { hasPermission } = useAuth();
  const dispatch = useAppDispatch();
  const confirmationModalInitialState = {
    show: false,
    title: "",
    dialog: "",
    onConfirm: () => {},
    showSwitch: false,
    switchLabel: "",
    switchValue: false,
    onSwitchChange: () => {},
  };
  const [confirmationModal, setConfirmationModal] = useState(
    confirmationModalInitialState
  );
  const carrerasList = useSelector(selectAlumnosCarreras);
  const [ipoError, setIpoError] = useState({
    identificacion: false,
    programa: false,
    orientacion: false,
  });
  const [ipoErrorAdicional, setIpoErrorAdicional] = useState({
    identificacion: false,
    programa: false,
    orientacion: false,
  });
  const [identificacionAdicional, setIdentificacionAdicional] = useState("");
  const [programaAdicional, setProgramaAdicional] = useState("");
  const [orientacionAdicional, setOrientacionAdicional] = useState("");
  const [idPersonaInput, setIdPersonaInput] = useState("");
  const [idPersonasList, setIdPersonasList] = useState<number[]>([]);
  const resetearCursosFijados = useRef(false);

  const clearConfirmationModal = () => {
    setConfirmationModal(confirmationModalInitialState);
    resetearCursosFijados.current = false
  };

  const setLoading = (loaderState: boolean) => {
    dispatch(setLoadingPageScreen(loaderState));
  };

  useEffect(() => {
    ObtenerAlumnosInicializados();
  }, []);

  const handleInicializarAlumno = async () => {
    setLoading(true);
    clearConfirmationModal();
    await dispatch(inicializarAlumno(email));
    setEmail("");
    setLoading(false);
  };

  const handleInicializarAlumnosPorIdPersona = async () => {
    setLoading(true);
    clearConfirmationModal();
    try {
      const response = await dispatch(
        inicializarAlumnosByIdPersonaList(idPersonasList)
      );
      if (!isFulfilled(response)) {
        throw new Error(response.error.message);
      } else {
        if (response.payload) {
          toastSuccess(response.payload);
        } else {
          toastError("Error al inicializar alumnos");
        }
      }
      setIdPersonasList([]);
    } catch (error) {
      console.log("error :>> ", error);
      toastError("Error al inicializar alumnos");
    }
    setLoading(false);
  };

  const agregarIdPersona = () => {
    const idPersona = parseInt(idPersonaInput);
    if (idPersona && !idPersonasList.includes(idPersona)) {
      setIdPersonasList([...idPersonasList, idPersona]);
      setIdPersonaInput("");
    } else if (idPersonasList.includes(idPersona)) {
      toastError("Este ID ya está en la lista");
    }
  };

  const borrarIdPersona = (idPersona: number) => {
    setIdPersonasList(idPersonasList.filter((id) => id !== idPersona));
  };

  const limpiarListaIdPersonas = () => {
    setIdPersonasList([]);
  };

  const ObtenerAlumnosInicializados = async () => {
    setLoading(true);
    try {
      await dispatch(getAlumnosInicializados());
    } catch (error) {
      console.log("error :>> ", error);
    }
    setLoading(false);
  };

  const BorrarTodosLosAlumnos = async () => {
    setLoading(true);
    try {
      await dispatch(postBorrarTodosLosAlumnos());
    } catch (error) {
      console.log("error :>> ", error);
    }
    clearConfirmationModal();
    setLoading(false);
  };

  const VencerOfertas = async () => {
    setLoading(true);
    try {
      const i: number | null =
        identificacion && identificacion.length > 0
          ? Number(identificacion)
          : null;
      const p: number | null =
        programa && programa.length > 0 ? Number(programa) : null;
      const o: number | null =
        orientacion && orientacion.length > 0 ? Number(orientacion) : null;
      await dispatch(postVencerOfertas({ i, p, o }));
      setIdentificacion("");
      setOrientacion("");
      setPrograma("");
    } catch (error) {
      console.log("error :>> ", error);
    }
    clearConfirmationModal();
    setLoading(false);
  };

  const BorrarIPO = async () => {
    setLoading(true);
    try {
      const i: number | null =
        identificacion && identificacion.length > 0
          ? Number(identificacion)
          : null;
      const p: number | null =
        programa && programa.length > 0 ? Number(programa) : null;
      const o: number | null =
        orientacion && orientacion.length > 0 ? Number(orientacion) : null;
      await dispatch(postBorrarIPO({ i, p, o }));
      setIdentificacion("");
      setOrientacion("");
      setPrograma("");
    } catch (error) {
      console.log("error :>> ", error);
    }
    clearConfirmationModal();
    setLoading(false);
  };

  const ResetearIPO = async () => {
    setLoading(true);
    try {
      const i: number | null =
        identificacion && identificacion.length > 0
          ? Number(identificacion)
          : null;
      const p: number | null =
        programa && programa.length > 0 ? Number(programa) : null;
      const o: number | null =
        orientacion && orientacion.length > 0 ? Number(orientacion) : null;
      const response = await dispatch(postResetearIPO({ i, p, o, resetearCursosFijados: resetearCursosFijados.current }));
      if (response.payload) {
        toastSuccess(
          <>
            Reseteando alumnos por IPO. <br />
            <strong>{response.payload.message}</strong>
          </>,
          { autoClose: 8000 }
        );
      } else {
        toastError();
      }
      setIdentificacion("");
      setOrientacion("");
      setPrograma("");
      resetearCursosFijados.current = false;
    } catch (error) {
      console.log("error :>> ", error);
    }
    clearConfirmationModal();
    setLoading(false);
  };

  const InvalidarOfertas = async () => {
    setLoading(true);
    try {
      const i: number | null =
        identificacion && identificacion.length > 0
          ? Number(identificacion)
          : null;
      const p: number | null =
        programa && programa.length > 0 ? Number(programa) : null;
      const o: number | null =
        orientacion && orientacion.length > 0 ? Number(orientacion) : null;
      await dispatch(postInvalidarOfertas({ i, p, o }));
      setIdentificacion("");
      setOrientacion("");
      setPrograma("");
    } catch (error) {
      console.log("error :>> ", error);
    }
    clearConfirmationModal();
    setLoading(false);
  };

  const SincronizarAlumnos = async () => {
    setLoading(true);
    try {
      const i: number | null =
        identificacion && identificacion.length > 0
          ? Number(identificacion)
          : null;
      const p: number | null =
        programa && programa.length > 0 ? Number(programa) : null;
      const o: number | null =
        orientacion && orientacion.length > 0 ? Number(orientacion) : null;
      const response = await dispatch(postSincronizarAlumnos({ i, p, o }));
      setIdentificacion("");
      setOrientacion("");
      setPrograma("");
      console.log("SincronizarAlumnos response :>> ", response.payload);
      if (response.payload) {
        toastSuccess(
          <>
            Inicializando alumnos por IPO. <br />
            <strong>{response.payload.message}</strong>
          </>,
          { autoClose: 8000 }
        );
      } else {
        toastError("No se encontraron alumnos para inicializar");
      }
    } catch (error) {
      console.log("error :>> ", error);
    }
    clearConfirmationModal();
    setLoading(false);
  };

  const SincronizarAlumnosPorPromocion = async () => {
    setLoading(true);
    try {
      const i = Number(identificacionAdicional) || null;
      const p = Number(programaAdicional) || null;
      const o = Number(orientacionAdicional) || null;
      const prom = Number(promocion);
      const m = Number(mes);
      const response = await dispatch(
        postSincronizarAlumnosPorPromocion({ i, p, o, prom, m })
      );
      setIdentificacionAdicional("");
      setOrientacionAdicional("");
      setProgramaAdicional("");
      if (response.payload) {
        toastSuccess(
          <>
            Inicializando alumnos por IPO y promoción. <br />
            <strong>{response.payload.message}</strong>
          </>,
          { autoClose: 8000 }
        );
      } else {
        toastError("No se encontraron alumnos para inicializar");
      }
    } catch (error) {
      console.log("error :>> ", error);
    }
    clearConfirmationModal();
    setLoading(false);
  };

  const handleIPOSelected = async (ipo: any, estado: string) => {
    const carrera = carrerasList.find((carrera: string) =>
      carrera.includes(ipo)
    );

    const estadoNormalizado = normalizeEstado(estado);
    const estadoEnum = EstadoAlumnoCarrera[estadoNormalizado as keyof typeof EstadoAlumnoCarrera];
    if (carrera) {
      setLoading(true);
      await dispatch(setCarreraSearch(carrera));
      await dispatch(setEstadoAlumnoSearch(estadoEnum.toString()));
      await dispatch(setRegistradosCurrentPage(1));
      await dispatch(getAlumnosRegistrados());
      setLoading(false);
    }
  };

  const validateIPOFields = () => {
    const errors = {
      identificacion: !identificacion,
      programa: !programa,
      orientacion: !orientacion,
    };
    setIpoError(errors);
    return !Object.values(errors).some((error) => error);
  };

  const validateIPOPromocionFields = () => {
    const errors = {
      identificacion: !identificacionAdicional,
      programa: !programaAdicional,
      orientacion: !orientacionAdicional,
    };
    setIpoErrorAdicional(errors);
    return !Object.values(errors).some((error) => error);
  };

  const handleIPOAction = (action: () => void, actionName: string) => {
    if (!validateIPOFields()) {
      toastError("Todos los campos I-P-O son obligatorios");
      return;
    }
    setConfirmationModal({
      show: true,
      onConfirm: action,
      title: `¿Desea ${actionName} para el IPO ${identificacion}-${programa}-${orientacion} ?`,
      dialog: "",
      showSwitch: false,
      switchLabel: "",
      switchValue: false,
      onSwitchChange: () => {},
    });
  };

  const handleIPOActionResetear = () => {
    if (!validateIPOFields()) {
      toastError("Todos los campos I-P-O son obligatorios");
      return;
    }
    setConfirmationModal({
      show: true,
      onConfirm: ResetearIPO,
      title: `¿Desea resetear alumnos para el IPO ${identificacion}-${programa}-${orientacion} ?`,
      dialog: "",
      showSwitch: true,
      switchLabel: "Resetear cursos fijados",
      switchValue: resetearCursosFijados.current,
      onSwitchChange: () => {
        resetearCursosFijados.current = !resetearCursosFijados.current
      },
    });
  };

  const handleIPOPromocionAction = (action: () => void, actionName: string) => {
    if (!validateIPOPromocionFields()) {
      toastError("Todos los campos I-P-O son obligatorios");
      return;
    }
    setConfirmationModal({
      show: true,
      onConfirm: action,
      title: `¿Desea ${actionName} para el IPO ${identificacionAdicional}-${programaAdicional}-${orientacionAdicional} , mes ${mes} y promoción ${promocion} ?`,
      dialog: "",
      showSwitch: false,
      switchLabel: "",
      switchValue: false,
      onSwitchChange: () => {},
    });
  };

  return (
    <>
      <ModalConfirmation
        show={confirmationModal.show}
        onClose={clearConfirmationModal}
        onConfirm={confirmationModal.onConfirm}
        title={confirmationModal.title}
        message={confirmationModal.dialog}
        showSwitch={confirmationModal.showSwitch}
        switchLabel={confirmationModal.switchLabel}
        switchValue={confirmationModal.switchValue}
        onSwitchChange={confirmationModal.onSwitchChange}
      />
      {alumnosInicializados && (
        <div className="bg-white p-6 rounded-lg border-2 border-cardBorder col-span-5 grid grid-cols-5">
          <h4 className="font-semibold text-grey_dark mb-3 text-[16px] col-span-5">
            IPOs Estado y cantidad
          </h4>

          <div className="col-span-4 grid grid-cols-5 gap-2 text-xs">
            {alumnosInicializados.map((ipo: any, index: number) => (
              <button
                key={`${ipo.estado}-${ipo.ipo}-${index}`}
                onClick={() => handleIPOSelected(ipo.ipo, ipo.estado)}
                className={`rounded-lg bg-[#eee] border-[3px] hover:opacity-70 shadow-md flex flex-nowrap items-center max-h-6 overflow-hidden ${
                  ipo.estado === "INICIALIZADO"
                    ? "bg-primary border-primary"
                    : "border-[#eee]"
                }`}
              >
                <span className="bg-white rounded-md min-w-[55px] text-center font-semibold">
                  {ipo.ipo}
                </span>
                <span
                  title={ipo.estado}
                  className={`px-1 text-[10px] flex-grow whitespace-nowrap truncate overflow-hidden ${
                    ipo.estado === "INICIALIZADO" ? "text-white" : ""
                  }`}
                >
                  {ipo.estado}
                </span>
                <span className="bg-white px-1 rounded-full">
                  {ipo.cantidad}
                </span>
              </button>
            ))}
          </div>

          <div className="col-span-1 pl-4 flex flex-col gap-2">
            <button
              className="text-textPrimary font-bold hover:underline border-2 border-cardBorder px-3 py-1 rounded-lg hover:bg-cardBorder disabled:bg-cardBorder disabled:text-textSecondary"
              disabled={!hasPermission("alumnos", "actualizar_ipo")}
              onClick={ObtenerAlumnosInicializados}
            >
              Actualizar
            </button>
          </div>
        </div>
      )}

      <SlDrawer
        label="Inicializar alumnos"
        open={drawerInicializar}
        onSlAfterHide={() => dispatch(setDrawerInicializar(false))}
      >
        <div className="">
          <div className="space-y-2">
            <p className="font-bold text-sm text-grey_dark">
              Ingrese uno o varios mails de alumno separados por , para
              inicializarlos
            </p>
            <Input
              className="w-full"
              placeholder="alumno@mail.utdt, alumno2@mail.utdt"
              onChange={(text) => setEmail(text)}
            />
            <Button
              className="w-full mt-2"
              onClick={() => {
                setConfirmationModal({
                  show: true,
                  onConfirm: handleInicializarAlumno,
                  title: "¿Desea inicializar vía mails?",
                  dialog: "",
                  showSwitch: false,
                  switchLabel: "",
                  switchValue: false,
                  onSwitchChange: () => {},
                });
              }}
              label="Inicializar"
            />
          </div>
          <div className="mt-5 space-y-2">
            <Divider color="gray" />
            <p className="font-bold text-sm mt-2 text-grey_dark">
              Inicializar por ID de Persona
            </p>
            <div className="flex gap-2">
              <Input
                className="flex-1"
                placeholder="Ingrese ID de persona"
                value={idPersonaInput}
                onChange={(text) => setIdPersonaInput(text.replace(/\D/g, ""))}
                type="number"
              />
              <Button
                theme="primary"
                size="small"
                onClick={agregarIdPersona}
                disabled={!idPersonaInput}
              >
                Agregar
              </Button>
            </div>

            {idPersonasList.length > 0 && (
              <div className="space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-sm font-semibold text-grey_dark">
                    IDs agregados ({idPersonasList.length}):
                  </span>
                  <Button
                    theme="danger"
                    size="small"
                    onClick={limpiarListaIdPersonas}
                  >
                    Limpiar lista
                  </Button>
                </div>
                <div className="h-20 border rounded-md p-2 bg-gray-50 overflow-y-auto">
                  <div className="grid grid-cols-3 gap-1">
                    {idPersonasList.map((idPersona, index) => (
                      <div
                        key={index}
                        className="flex justify-between items-center py-1 px-2 bg-white rounded border text-xs"
                      >
                        <span className="truncate">{idPersona}</span>
                        <button
                          onClick={() => borrarIdPersona(idPersona)}
                          className="text-red-500 hover:text-red-700 font-bold ml-1 flex-shrink-0"
                          title="Eliminar"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
                <Button
                  className="w-full"
                  onClick={() => {
                    setConfirmationModal({
                      show: true,
                      onConfirm: handleInicializarAlumnosPorIdPersona,
                      title: `¿Desea inicializar ${idPersonasList.length} alumno(s) por IdPersona?`,
                      dialog: "",
                      showSwitch: false,
                      switchLabel: "",
                      switchValue: false,
                      onSwitchChange: () => {},
                    });
                  }}
                  label={`Inicializar ${idPersonasList.length} alumno(s)`}
                />
              </div>
            )}
          </div>
          <div className="mt-5 space-y-2">
            <Divider color="gray" />
            <p className="font-bold text-sm mt-2 text-grey_dark">
              Inicializar por Identificacion, Programa, Orientacion
            </p>
            <div className="flex items-center justify-center w-full gap-2">
              <Input
                className={`ipoField w-14 ${
                  ipoError.identificacion ? "border-red border-2" : ""
                }`}
                placeholder="I"
                value={identificacion}
                onChange={(text) => {
                  setIdentificacion(text);
                  setIpoError((prev) => ({ ...prev, identificacion: false }));
                }}
                required
              />
              <span>-</span>
              <Input
                className={`ipoField w-14 ${
                  ipoError.programa ? "border-red border-2" : ""
                }`}
                placeholder="P"
                value={programa}
                onChange={(text) => {
                  setPrograma(text);
                  setIpoError((prev) => ({ ...prev, programa: false }));
                }}
                required
              />
              <span>-</span>
              <Input
                className={`ipoField w-14 ${
                  ipoError.orientacion ? "border-red border-2" : ""
                }`}
                placeholder="O"
                value={orientacion}
                onChange={(text) => {
                  setOrientacion(text);
                  setIpoError((prev) => ({ ...prev, orientacion: false }));
                }}
                required
              />
            </div>
            <br />
            <div className="flex gap-2">
              <Button
                theme="primary"
                size="small"
                className="w-1/3"
                onClick={() => {
                  handleIPOAction(SincronizarAlumnos, "inicializar alumnos");
                }}
              >
                Inicializar
              </Button>

              <Button
                theme="default"
                size="small"
                className="w-1/3"
                onClick={() => {
                  handleIPOActionResetear();
                }}
              >
                Resetear
              </Button>

              <Button
                theme="danger"
                size="small"
                className="w-1/3"
                onClick={() => {
                  handleIPOAction(BorrarIPO, "eliminar alumnos");
                }}
              >
                Borrar
              </Button>
            </div>
            <div className="flex gap-2">
              <Button
                theme="warning"
                size="small"
                className="w-1/2"
                onClick={() => {
                  handleIPOAction(InvalidarOfertas, "invalidar ofertas");
                }}
              >
                Invalidar ofertas
              </Button>

              <Button
                theme="danger"
                size="small"
                className="w-1/2"
                onClick={() => {
                  handleIPOAction(VencerOfertas, "vencer ofertas");
                }}
              >
                Vencer ofertas
              </Button>
            </div>
          </div>
          <div className="mt-5 space-y-2">
            <Divider color="gray" />
            <p className="font-bold text-sm mt-2 text-grey_dark">
              Inicializar por IPO y promoción
            </p>
            <div className="flex items-center justify-center w-full gap-2">
              <Input
                className={`ipoField w-14 ${
                  ipoErrorAdicional.identificacion ? "border-red border-2" : ""
                }`}
                placeholder="I"
                value={identificacionAdicional}
                onChange={(text) => {
                  setIdentificacionAdicional(text);
                  setIpoErrorAdicional((prev) => ({
                    ...prev,
                    identificacion: false,
                  }));
                }}
                required
              />
              <span>-</span>
              <Input
                className={`ipoField w-14 ${
                  ipoErrorAdicional.programa ? "border-red border-2" : ""
                }`}
                placeholder="P"
                value={programaAdicional}
                onChange={(text) => {
                  setProgramaAdicional(text);
                  setIpoErrorAdicional((prev) => ({
                    ...prev,
                    programa: false,
                  }));
                }}
                required
              />
              <span>-</span>
              <Input
                className={`ipoField w-14 ${
                  ipoErrorAdicional.orientacion ? "border-red border-2" : ""
                }`}
                placeholder="O"
                value={orientacionAdicional}
                onChange={(text) => {
                  setOrientacionAdicional(text);
                  setIpoErrorAdicional((prev) => ({
                    ...prev,
                    orientacion: false,
                  }));
                }}
                required
              />
            </div>

            <div className="flex items-center justify-center w-full gap-2 mt-2">
              <div className="w-1/2">
                <label className="font-bold text-grey_dark">Promoción</label>
                <select
                  className="w-full p-2 border rounded-md"
                  value={promocion}
                  onChange={(e) => setPromocion(e.target.value)}
                >
                  {Array.from(
                    { length: 10 },
                    (_, i) => moment().year() - 9 + i
                  ).map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <div className="w-1/2">
                <label className="font-bold text-grey_dark">Mes</label>
                <select
                  className="w-full p-2 border rounded-md"
                  value={mes}
                  onChange={(e) => setMes(e.target.value)}
                >
                  {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                    <option key={month} value={month}>
                      {month}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <Button
              className="w-full mt-2"
              onClick={() => {
                handleIPOPromocionAction(
                  SincronizarAlumnosPorPromocion,
                  "inicializar alumnos por promoción"
                );
              }}
            >
              Inicializar
            </Button>
          </div>
        </div>
      </SlDrawer>
    </>
  );
}

export default AlumnosInicializados;
